/* eslint-disable @next/next/no-img-element */
import useCommon from '@utils/hooks/common';
import React, {useContext} from 'react';
import {Button} from 'antd';
import styles from './styles';
import {EmojiContext} from '@utils/context';
import EmbossedContainer from '@components/EmbossedContainer';

interface EmojiItemButtonInterface {
  buttonFunction?: () => void;
  diamondNeeded: number;
  ownedAmount: number;
  emojiImage: JSX.Element;
  emojiId?: number;
}

const EmojiItemButton = React.memo((props: EmojiItemButtonInterface): JSX.Element => {
  const {classes, t} = useCommon({
    withTranslation: ['emojiPanel'],
    withStyles: styles,
  });
  const {buttonFunction, diamondNeeded, ownedAmount, emojiImage, emojiId} = props;
  const {isEmojiSending} = useContext(EmojiContext);

  return (
    <EmbossedContainer className={classes.emojiGridCell} onClick={buttonFunction}>
      {/* <img src={`${NEXT_PUBLIC_URL}${emoji.image}`} alt="emoji" height={50} width={50} /> */}
      {emojiImage}
      {diamondNeeded > 0 ? (
        <div className={classes.priceSection}>
          <img
            className={classes.diamondImage}
            src="/icon/user-profile/diamond.svg"
            // srcSet="/icon/blue-diamond-2.png"
            alt="diamond"
          />
          <span className={classes.priceTag}>{diamondNeeded}</span>
        </div>
      ) : (
        <div className={classes.priceTag}>{t('free')}</div>
      )}
      <div className={classes.amountArea}>{diamondNeeded > 0 ? ownedAmount : '∞'}</div>
    </EmbossedContainer>
  );
});

export default EmojiItemButton;
EmojiItemButton.displayName = 'EmojiItemButton';
